import { Component, Input, OnInit } from '@angular/core';
import { EdiHistoryService } from '../../../../services/edi-history.service';
import { EdiHistory } from '../../../../models/edi-history.model';
import { mapAsBody } from '../../util/request-util';
import dayjs from 'dayjs';
import { EdiTransporterConfigurationService } from '../../../../services/edi-transporter-configuration.service';

@Component({
  selector: 'jhi-transport-edi-history[transportOrderId]',
  templateUrl: './transport-edi-history.component.html',
  styleUrls: ['./transport-edi-history.component.scss'],
})
export class TransportEdiHistoryComponent implements OnInit {
  @Input() transportOrderId?: number;

  ediHistories: EdiHistory[] = [];

  displayDownloadEdiFile = true;

  constructor(private ediHistoryService: EdiHistoryService, private ediTransporterConfigurationService: EdiTransporterConfigurationService) {}

  ngOnInit(): void {
    if (this.transportOrderId) {
      this.ediHistoryService
        .findAllForTransportOrder(this.transportOrderId)
        .pipe(mapAsBody)
        .subscribe(ediHistories => {
          // recherche du transporter en cours var l'objet transporter dans ediHistories ne contient que l'id du transporter:
          this.ediHistories = ediHistories ?? [];
        });
    }
    this.ediTransporterConfigurationService
      .retrieveConfiguration()
      .pipe(mapAsBody)
      .subscribe(ediTransporterConfig => {
        this.displayEdiFile(ediTransporterConfig!.ediId);
      });
  }

  writeLine(ediHistory: EdiHistory, index: number): string {
    if (index === 0) {
      return 'Envoyé le ' + dayjs(ediHistory.date).format('DD/MM/YYYY') + ' par ' + ediHistory.author?.toUpperCase();
    } else {
      return 'Renvoyé le ' + dayjs(ediHistory.date).format('DD/MM/YYYY') + ' par ' + ediHistory.author?.toUpperCase();
    }
  }

  downloadEdiFile(ediHistory: EdiHistory): void {
    const splits = ediHistory.filePath!.split('/');
    this.ediHistoryService.download(ediHistory.id!, splits[splits.length - 1]);
  }

  displayEdiFile(ediId?: string): boolean {
    let displayIcon = true;
    if (ediId?.match(/^([0-9][0-9][0-9])-([0-9][0-9][0-9])-([0-9][0-9][0-9][0-9])$/)) {
      displayIcon = false;
    }
    return displayIcon;
  }
}
